import {objectToQuery} from '@jetbrains/teamcity-ui/dist/utils'
import {skipToken} from '@reduxjs/toolkit/query'
import type {ConnectedProps} from 'react-redux'
import {connect} from 'react-redux'

import {useIsMine} from '../../../hooks/useIsMine'
import type {State} from '../../../reducers/types'
import {getSingleBuildArg} from '../../../rest/builds'
import {getBuildLocator} from '../../../rest/locators'
import {getOverviewHref} from '../../../routes'
import {
  getBuild,
  getIsSakuraUI,
  getPipelineBatchIdFromBuildId,
  getPipelineJobIdFromBuildId,
  getPipelineRunIdFromBuildId,
  getPipelineIdFromBuildId,
} from '../../../selectors'
import {restApi} from '../../../services/rest'
import type {BuildId} from '../../../types'
import {resolveWebEntityLink, WebEntityType} from '../../../utils/entityLinks'

import BuildNumberComponent from './BuildNumber'

type OwnProps = {
  buildId: BuildId | null | undefined
  number?: string
  withLink?: boolean
  hideStar?: boolean
  className?: string
  showEmptyStar?: boolean
  withWarnings?: boolean
  withComment?: boolean
  withStatusChangeComment?: boolean
}

const mapStateToProps = (state: State, props: OwnProps) => {
  const build = getBuild(state, props.buildId)
  const isSakuraUI = getIsSakuraUI(state)
  const {number, personal, canceledInfo, queuePosition} = build || {}
  const pipelineId = getPipelineIdFromBuildId(state, props.buildId)
  const runId = getPipelineRunIdFromBuildId(state, props.buildId)
  const jobId = getPipelineJobIdFromBuildId(state, props.buildId)
  const batchId = getPipelineBatchIdFromBuildId(state, props.buildId)
  const href = isSakuraUI
    ? getOverviewHref({
        buildId: props.buildId,
        buildTypeId: build?.buildType,
        pipelineId,
        runId,
      }).concat(
        jobId ? `?${objectToQuery({job: jobId ?? null, pageFullLogBuildId: batchId ?? null})}` : '',
      )
    : resolveWebEntityLink(WebEntityType.BUILD, props.buildId, false)
  return {
    href,
    queuePosition,
    loaded: number != null || queuePosition != null || props.number != null,
    number: number ?? props.number,
    isPersonal: personal === true,
    isQueued: build?.state === 'queued',
    isCanceled: canceledInfo != null,
  }
}

const connector = connect(mapStateToProps)

type Props = OwnProps & ConnectedProps<typeof connector>

const BuildNumberContainer = connector(function BuildNumberContainer({
  buildId,
  loaded,
  ...restProps
}: Props) {
  restApi.endpoints.getBuildNormalized.useQuerySubscription(
    buildId != null && !loaded
      ? getSingleBuildArg(getBuildLocator(buildId), {
          withRunningInfo: false,
          withPipelineRuns: true,
          withAnchorBuild: true,
        })
      : skipToken,
  )
  const isMine = useIsMine(buildId)
  return loaded && buildId != null ? (
    <BuildNumberComponent {...restProps} buildId={buildId} isMine={isMine} />
  ) : null
})
export default BuildNumberContainer
